export default __webpack_public_path__ + "static/media/question.d243b5cc.svg";